// utils/hooks/useContractData.js
import { useMaxSupply, useTier1, useTier2, useTier3, useTier1Supply, useTier2Supply, useCurrentTier, useTier1Minted, useTier2Minted, useTier3Minted, useImageURI } from '../utils/contracts/mintContractMethods';
import { Spinner } from '@chakra-ui/react';

const useContractMintData = () => {
	const {
		data: maxSupplyData,
		isSuccess: isMaxSupplySuccess,
		refetch: refetchMaxSupply,
	} = useMaxSupply();

	const {
		data: tier1SupplyData,
		isSuccess: isTier1SupplySuccess,
		refetch: refetchTier1Supply,
	} = useTier1Supply();

	const {
		data: tier2SupplyData,
		isSuccess: isTier2SupplySuccess,
		refetch: refetchTier2Supply,
	} = useTier2Supply();

	const {
		data: tier1Data,
		isSuccess: isTier1Success,
		refetch: refetchTier1,
	} = useTier1();

	const {
		data: tier2Data,
		isSuccess: isTier2Success,
		refetch: refetchTier2,
	} = useTier2();

	const {
		data: tier3Data,
		isSuccess: isTier3Success,
		refetch: refetchTier3,
	} = useTier3();

	const {
		data: currentTierData,
		isSuccess: isTierSuccess,
		refetch: refetchCurrentTier,
	} = useCurrentTier();

	const {
		data: tier1MintedData,
		isSuccess: isTier1MintedSuccess,
		refetch: refetchTier1Minted,
	} = useTier1Minted();

	const {
		data: tier2MintedData,
		isSuccess: isTier2MintedSuccess,
		refetch: refetchTier2Minted,
	} = useTier2Minted();

	const {
		data: tier3MintedData,
		isSuccess: isTier3MintedSuccess,
		refetch: refetchTier3Minted,
	} = useTier3Minted();

	const {
		data: imageURIData,
		isSuccess: isImageURISuccess,
		refetch: refetchImageURI,
	} = useImageURI();

	const tierData = [
		// {
		// 	name: 'Tier 1',
		// 	price: isTier1Success ? ethers.formatEther(tier1Data) : <Spinner />,
		// 	supply: isTier1SupplySuccess ? tier1SupplyData.toString() : <Spinner />,
		// 	minted: isTier1MintedSuccess ? tier1MintedData.toString() : <Spinner />,
		// 	discount: '50'
		// },
		// {
		// 	name: 'Tier 2',
		// 	price: isTier2Success ? ethers.formatEther(tier2Data) : <Spinner />,
		// 	supply: isTier1SupplySuccess && isTier2SupplySuccess ? (tier2SupplyData - tier1SupplyData).toString() : <Spinner />,
		// 	minted: isTier2MintedSuccess ? tier2MintedData.toString() : <Spinner />,
		// 	discount: '25'
		// },
		{
			name: 'Tier 4',
			price: '0.001725',
			// supply: isMaxSupplySuccess && isTier2SupplySuccess ? (maxSupplyData - tier2SupplyData).toString() : <Spinner />,
			supply: isMaxSupplySuccess && isTier2SupplySuccess ? '2350' : <Spinner />,
			minted: isTier3MintedSuccess ? (600 + parseInt(tier3MintedData)).toString() : <Spinner />,
			discount: '40'
		},
		{
			name: 'Tier 5',
			price: 0.001985,
			// supply: isMaxSupplySuccess && isTier2SupplySuccess ? (maxSupplyData - tier2SupplyData).toString() : <Spinner />,
			supply: isMaxSupplySuccess && isTier2SupplySuccess ? '2500' : <Spinner />,
			minted: 0,
			discount: '15'
		},
		{
			name: 'Tier 6',
			price: 0.002415,
			// supply: isMaxSupplySuccess && isTier2SupplySuccess ? (maxSupplyData - tier2SupplyData).toString() : <Spinner />,
			supply: isMaxSupplySuccess && isTier2SupplySuccess ? '2800' : <Spinner />,
			minted: 0,
			discount: '0'
		}
	];

	return {
		maxSupplyData,
		isMaxSupplySuccess,
		tierData,
		currentTierData,
		imageURIData,
		isTier1Success,
		isTier2Success,
		isTier3Success
	};
};

export default useContractMintData;
